import {
  AccountOrganizerAthonPledgesDataPageType,
  AccountOrganizerAthonPledgesListRequestType,
  AccountOrganizerAthonPledgesListType,
} from 'src/models/Account/athonPledges';
import {
  AccountOrganizerAuthorizationOrder,
  AccountOrganizerClientSecret,
} from 'src/models/Account/Organizer';
import {
  AccountOrganizerContributionsResponseType,
  AccountOrganizerGetContributionsParamsType,
} from 'src/models/Account/Organizer/contributions';
import {
  AccountOrganizerContributionsChangeAuthorizationOrderRequestType,
  AccountOrganizerContributionsChangePaymentMethodRequestType,
  AccountOrganizerContributionsDeliveredRequestType,
} from 'src/models/Account/Organizer/contributions/donations';
import {
  AccountOrganizerContributionsLedgerListType,
  AccountOrganizerContributionsLedgerRequestType,
} from 'src/models/Account/Organizer/contributions/ledger';
import {
  AccountOrganizerDeleteRegisteredDonorRequestType,
  AccountOrganizerEditRegisteredDonorRequestType,
  AccountOrganizerFindRegisteredDonorRequestType,
  AccountOrganizerFindRegisteredDonorResponseType,
  AccountOrganizerRegisteredDonorsListRequestType,
  AccountOrganizerRegisteredDonorsListType,
  AccountOrganizerRegisteredDonorsViewResponseType,
} from 'src/models/Account/Organizer/registeredDonors';
import {
  AccountOrganizerNewFundRequestType,
  AccountOrganizerNewFundResponseType,
  AccountOrganizerRequestFundsListType,
  AccountOrganizerRequestFundsWithdrawCampaignRequestType,
  AccountOrganizerRequestFundsWithdrawCampaignResponseType,
} from 'src/models/Account/Organizer/requestFunds';
import {
  AccountOrganizerSoldItemsListRequestType,
  AccountOrganizerSoldItemsListType,
} from 'src/models/Account/Organizer/soldItems';
import {
  AccountOrganizerSweepstakeOfflineEntriesDataPageType,
  AccountOrganizerSweepstakeOfflineEntriesListItemType,
  AccountOrganizerSweepstakeOfflineEntriesListRequestType,
  AccountOrganizerSweepstakeOfflineEntriesListType,
  SweepstakeOfflineEntriesDeleteRequest,
  SweepstakeOfflineEntryModel,
} from 'src/models/Account/Organizer/SweepstakeOfflineEntries';
import {
  AccountOrganizerSweepstakesEntriesDataPageType,
  AccountOrganizerSweepstakesEntriesListRequestType,
  AccountOrganizerSweepstakesEntriesListType,
} from 'src/models/Account/Organizer/SweepstakesEntries';
import {
  AccountOrganizerResendTeamMemberInvitationRequestType,
  AccountOrganizerResendTeamMemberInvitationResponseType,
  AccountOrganizerResendTeamMemberInvitationsToAllRequestType,
  AccountOrganizerTeamMemberInvitationsCsvRequestType,
  AccountOrganizerTeamMemberInvitationsCsvResponseType,
  AccountOrganizerTeamMemberInvitationsListRequestType,
  AccountOrganizerTeamMemberInvitationsListType,
  AccountOrganizerTeamMemberInvitationsPageDataType,
} from 'src/models/Account/Organizer/teamMemberInvitations';
import { APIExportStartReturnType } from 'src/models/BaseApi';
import { SendEmailToSelectedUserRequestType, SendEmailToSelectedUserResponseType } from 'src/models/Modals/SendEmail';
import { ViewDetailsModalResponseType } from 'src/models/Modals/viewDetails';
import { ApiFunctionType, httpGetCancellable, httpPost, httpPostCancellable } from 'src/utils/http';

const getPath = (path: string) => `/account/organizer/${path}`;

export const apiSignOut = (
  returnUrl: string | null
): Promise<{
  RedirectUrl: string | null;
}> => httpPost('/LoginDispatcher/signout', { returnUrl });

export const apiSendEmailToSelectedUsers: ApiFunctionType<
  SendEmailToSelectedUserRequestType,
  SendEmailToSelectedUserResponseType
> = httpPostCancellable(getPath('SendEmailToSelectedUsers'));

/* fund requests */
export const apiLoadFundRequests: ApiFunctionType<{ permanentUrl: string }, AccountOrganizerRequestFundsListType> =
  httpPostCancellable(getPath('LoadFundRequests'));

export const apiNewFundRequest: ApiFunctionType<
  AccountOrganizerNewFundRequestType,
  AccountOrganizerNewFundResponseType
> = httpPostCancellable(getPath('NewFundRequest'));

export const apiLoadWithdrawCampaignFundModel: ApiFunctionType<
  { permanentUrl: string },
  AccountOrganizerRequestFundsWithdrawCampaignResponseType
> = httpPostCancellable(getPath('LoadWithdrawCampaignFundModel'));

export const apiNewFundRequestWithFundingDataSaving: ApiFunctionType<
  AccountOrganizerRequestFundsWithdrawCampaignResponseType,
  AccountOrganizerRequestFundsWithdrawCampaignRequestType
> = httpPostCancellable(getPath('NewFundRequestWithFundingDataSaving'));

export const apiRequestFundsCsv: ApiFunctionType<{ permanentUrl: string }, APIExportStartReturnType> =
  httpPostCancellable(getPath('RequestFundsCsv'));
/* fund requests end */

/** sweepstake offline entries */
export const apiGetSweepstakeOfflineEntriesPageData: ApiFunctionType<
  { permanentUrl: string },
  AccountOrganizerSweepstakeOfflineEntriesDataPageType
> = httpGetCancellable(getPath('GetSweepstakeOfflineEntries'));

export const apiGetSweepstakeOfflineEntries: ApiFunctionType<
  AccountOrganizerSweepstakeOfflineEntriesListRequestType,
  AccountOrganizerSweepstakeOfflineEntriesListType
> = httpPostCancellable(getPath('ListSweepstakeOfflineEntries'));

export const apiSaveSweepstakeOfflineEntry: ApiFunctionType<SweepstakeOfflineEntryModel, SweepstakeOfflineEntryModel> =
  httpPostCancellable(getPath('SaveSweepstakeOfflineEntry'));

export const apiSaveSweepstakeOfflineEntryByNumber: ApiFunctionType<
  SweepstakeOfflineEntriesDeleteRequest,
  SweepstakeOfflineEntryModel
> = httpPostCancellable(getPath('SaveSweepstakeOfflineEntryByEntryNumber'));

export const apiDeleteSweepstakeOfflineEntry: ApiFunctionType<
  AccountOrganizerSweepstakeOfflineEntriesListItemType,
  SweepstakeOfflineEntryModel
> = httpPostCancellable(getPath('DeleteSweepstakeOfflineEntry'));

export const apiDeleteSweepstakeOfflineEntryByNumber: ApiFunctionType<
  AccountOrganizerSweepstakeOfflineEntriesListItemType,
  SweepstakeOfflineEntryModel
> = httpPostCancellable(getPath('DeleteSweepstakeOfflineEntryByEntryNumber'));

export const apiExportSweepstakeOfflineEntries: ApiFunctionType<{ permanentUrl: string }, APIExportStartReturnType> =
  httpPostCancellable(getPath('SweepstakeOfflineEntriesCsv'));
/** sweepstake offline entries end */

/** sweepstakes entries */
export const apiGetSweepstakesEntriesPageData: ApiFunctionType<
  { PermanentUrl: string },
  AccountOrganizerSweepstakesEntriesDataPageType
> = httpGetCancellable(getPath('GetSweepstakesEntries'));

export const apiGetSweepstakesEntries: ApiFunctionType<
  AccountOrganizerSweepstakesEntriesListRequestType,
  AccountOrganizerSweepstakesEntriesListType
> = httpPostCancellable(getPath('LoadSweepstakesEntries'));

export const apiExportSweepstakesEntries: ApiFunctionType<{ permanentUrl: string }, APIExportStartReturnType> =
  httpPostCancellable(getPath('SweepstakesEntriesTableCsv'));

export const apiExportSweepstakesTickets: ApiFunctionType<{ permanentUrl: string }, APIExportStartReturnType> =
  httpPostCancellable(getPath('SweepstakesEntriesCsv'));
/** sweepstakes entries end */

/** team member invitations */
export const apiOrganizerTeamMemberInvitationsGetPageInfo: ApiFunctionType<
  { permanentUrl: string },
  AccountOrganizerTeamMemberInvitationsPageDataType
> = httpGetCancellable(getPath('GetTeamMemberInvitations'));

export const apiOrganizerLoadTeamMemberInvitations: ApiFunctionType<
  AccountOrganizerTeamMemberInvitationsListRequestType,
  AccountOrganizerTeamMemberInvitationsListType
> = httpPostCancellable(getPath('LoadTeamMemberInvitations'));

export const apiOrganizerResendTeamMemberInvitation: ApiFunctionType<
  AccountOrganizerResendTeamMemberInvitationRequestType,
  AccountOrganizerResendTeamMemberInvitationResponseType
> = httpPostCancellable(getPath('ResendTeamMemberInvitation'));

export const apiOrganizerResendTeamMemberInvitationsToAll: ApiFunctionType<
  AccountOrganizerResendTeamMemberInvitationsToAllRequestType,
  AccountOrganizerResendTeamMemberInvitationsToAllRequestType
> = httpPostCancellable(getPath('ResendTeamMemberInvitationsToAll'));

export const apiOrganizerTeamMemberInvitationsCsv: ApiFunctionType<
  AccountOrganizerTeamMemberInvitationsCsvRequestType,
  AccountOrganizerTeamMemberInvitationsCsvResponseType
> = httpPostCancellable(getPath('TeamMemberInvitationsCsv'));
/** team member invitations end */

/** athon pledges */
export const apiOrganizerAthonPledgesGetPageInfo: ApiFunctionType<
  { permanentUrl: string },
  AccountOrganizerAthonPledgesDataPageType
> = httpGetCancellable(getPath('GetAthonPledges'));

export const apiLoadAthonPledges: ApiFunctionType<
  AccountOrganizerAthonPledgesListRequestType,
  AccountOrganizerAthonPledgesListType
> = httpPostCancellable(getPath('LoadAthonPledges'));

export const apiOrganizerAthonPledgesCsv: ApiFunctionType<
  { permanentUrl: string; contributionID?: number | null },
  APIExportStartReturnType
> = httpPostCancellable(getPath('AthonPledgesCsv'));
/** athon pledges end */

/** sold items */
export const apiGetSoldItems: ApiFunctionType<{ permanentUrl: string }, AccountOrganizerSoldItemsListType> =
  httpGetCancellable(getPath('GetSoldItems'));

export const apiLoadSoldItems: ApiFunctionType<
  AccountOrganizerSoldItemsListRequestType,
  AccountOrganizerSoldItemsListType
> = httpPostCancellable(getPath('LoadSoldItems'));

export const apiSoldItemsCsv: ApiFunctionType<{ permanentUrl: string }, APIExportStartReturnType> =
  httpPostCancellable(getPath('SoldItemsCsv'));

export const apiSaleOrderSummaryCsv: ApiFunctionType<{ permanentUrl: string }, APIExportStartReturnType> =
  httpPostCancellable(getPath('SaleOrderSummaryCsv'));
/** end sold items */